export class ProjectInfoPropertyValueDef {
  // rotation-version of existing/old projects which were created/saved before introduction of rotationInfoVersion-property
  public static readonly ROTATION_INFO_VERSION_1_0: string = '1.0';
  // rotation-version of newly created projects (or projects created with sufficient/correct rotation-info-usage-property)
  public static readonly ROTATION_INFO_VERSION_2_0: string = '2.0';

  public static readonly BUILDING_BLOCK_CABLE_FED_SIDE_TOP: string = 'top';
  public static readonly BUILDING_BLOCK_CABLE_FED_SIDE_BOTTOM: string = 'bottom';
}
